



const styles = theme => ({

  contentRoot: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },

  inputRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    alignSelf: 'stretch',
    marginTop: 10,
    flexDirection: 'column',
  },

  textFieldRoot: {
    padding: 0,
    //marginLeft: 10,
    'label + &': {
      //marginTop: theme.spacing.unit * 3,
    },
  },

  textFieldInput: {
    borderRadius: 4,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 12px',
    width: 350,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: 200,
    },
    '&:focus': {
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },

  textFieldFormLabel: {
    fontSize: 18,
  },

  loadingContent: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },

});

export default styles;



// WEBPACK FOOTER //
// ./src/components/PrimaryContactDialog/styles.js